// 客服链接请求前缀
const onlineServiceOrgUrl = {
	cn: {
		sc: 'https://ocs2odp.sf-express.com/app/init',
		en: 'http://ocs2odp.sf-express.com/app/init'
	},
	hk: {
		sc: 'http://iocs-com.sf-express.com/live800/chatClient/chatbox.jsp',
		tc: 'http://iocs-com.sf-express.com/live800/chatClient/chatbox.jsp',
		en: 'http://iocs-com.sf-express.com/live800/chatClient/chatbox.jsp'
	},
	tw: {
		tc: 'https://ocs2odp.sf-express.com/app/init',
		en: 'http://iocs-com.sf-express.com/live800/chatClient/chatbox.jsp'
	},
	jp: {
		sc: 'https://ocs2odp.sf-express.com/app/init',
		ja: 'https://ocs2odp.sf-express.com/app/init',
		en: 'https://ocs2odp.sf-express.com/app/init'
	},
	my: {
		sc: 'https://ocs2odp.sf-express.com/app/init',
		en: 'https://ocs2odp.sf-express.com/app/init'
	},
	sg: {
		sc: 'https://ocs2odp.sf-express.com/app/init',
		en: 'https://ocs2odp.sf-express.com/app/init'
	},
	kr: {
		sc: 'https://ocs2odp.sf-express.com/app/init',
		en: 'https://ocs2odp.sf-express.com/app/init',
		ko: 'https://ocs2odp.sf-express.com/app/init'
	},
	us: {
		sc: 'https://ocs2odp.sf-express.com/app/init',
		en: 'https://ocs2odp.sf-express.com/app/init'
	},
	au: {
		sc: 'https://ocs2odp.sf-express.com/app/init',
		en: 'https://ocs2odp.sf-express.com/app/init'
	},
	th: {
		sc: 'https://ocs2odp.sf-express.com/app/init',
		en: 'https://ocs2odp.sf-express.com/app/init'
	}
}
//配的全部是生产环境  在线客服跳转链接
const onlineServiceUrl = {
	cn: {
		sc: 'https://ocs2odp.sf-express.com/app/init?orgName=sy&channelId=659&clientType=1',
		en: 'http://ocs2odp.sf-express.com/app/init?orgName=sy&channelId=523&clientType=1&accountId='
	},
	hk: {
		sc: 'http://iocs-com.sf-express.com/live800/chatClient/chatbox.jsp?companyID=9051&configID=32',
		tc: 'http://iocs-com.sf-express.com/live800/chatClient/chatbox.jsp?companyID=9051&configID=33',
		en: 'http://iocs-com.sf-express.com/live800/chatClient/chatbox.jsp?companyID=9051&configID=34'
	},
	tw: {
		tc: 'https://ocs2odp.sf-express.com/app/init?orgName=sy&channelId=517&clientType=2&accountId=',
		en: 'http://iocs-com.sf-express.com/live800/chatClient/chatbox.jsp?companyID=9051&configID=31'
	},
	jp: {
		sc: 'https://ocs2odp.sf-express.com/app/init?orgName=sy&channelId=705&clientType=1&accountId=',
		ja: 'https://ocs2odp.sf-express.com/app/init?orgName=sy&channelId=124&clientType=1&accountId= ',
		en: 'https://ocs2odp.sf-express.com/app/init?orgName=sy&channelId=462&clientType=1&accountId='
	},
	my: {
		sc: 'https://ocs2odp.sf-express.com/app/init?orgName=sy&channelId=347&clientType=1&accountId=',
		en: 'https://ocs2odp.sf-express.com/app/init?orgName=sy&channelId=798&clientType=1&accountId='
	},
	sg: {
		sc: 'https://ocs2odp.sf-express.com/app/init?orgName=sy&channelId=679&clientType=1&accountId=',
		en: 'https://ocs2odp.sf-express.com/app/init?orgName=sy&channelId=224&clientType=1&accountId='
	},
	kr: {
		sc: 'https://ocs2odp.sf-express.com/app/init?orgName=sy&channelId=660&clientType=1&accountId=',
		en: 'https://ocs2odp.sf-express.com/app/init?orgName=sy&channelId=330&clientType=1&accountId=',
		ko: 'https://ocs2odp.sf-express.com/app/init?orgName=sy&channelId=688&clientType=2&accountId='
	},
	us: {
		sc: 'https://ocs2odp.sf-express.com/app/init?orgName=sy&channelId=158&clientType=1&accountId=',
		en: 'https://ocs2odp.sf-express.com/app/init?orgName=sy&channelId=138&clientType=1&accountId='
	},
	au: {
		sc: 'https://ocs2odp.sf-express.com/app/init?orgName=sy&channelId=684&clientType=1&accountId=',
		en: 'https://ocs2odp.sf-express.com/app/init?orgName=sy&channelId=774&clientType=1&accountId='
	},
	th: {
		sc: 'https://ocs2odp.sf-express.com/app/init?orgName=sy&channelId=504&clientType=1&accountId=',
		en: 'https://ocs2odp.sf-express.com/app/init?orgName=sy&channelId=721&clientType=1&accountId='
	}
}

module.exports = {
	onlineServiceOrgUrl,
	onlineServiceUrl
}



// WEBPACK FOOTER //
// ./src/mixins/onlineService/config.js